import { isIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';

export const isLoggedOutError = (e: unknown): boolean =>
  isIpfError(e, 'API') &&
  e.payload?.response.code === 'API_INVALID_REFRESH_TOKEN';
